import { mapValues } from '@exodus/basic-utils'

/* @deprecated */
const CHAIN_DATA = {
  ethereum: {
    chainId: 1,
    serverUrl: 'https://geth.a.exodus.io/wallet/v1/',
    confirmationsNumber: 30,
  },
  ethereumclassic: {
    chainId: 61,
    serverUrl: 'https://getc.a.exodus.io/wallet/v1/',
    confirmationsNumber: 5000,
  },
  ethereumgoerli: {
    chainId: 5,
    serverUrl: 'https://geth-goerli-testnet-d.a.exodus.io/wallet/v1/',
    confirmationsNumber: 30,
  },
  ethereumholesky: {
    chainId: 17_000,
    serverUrl: 'https://geth-holesky-testnet-d.a.exodus.io/wallet/v1/',
    confirmationsNumber: 30,
  },
  ethereumsepolia: {
    chainId: 11_155_111,
    serverUrl: 'https://geth-sepolia-testnet-d.a.exodus.io/wallet/v1/',
    confirmationsNumber: 30,
  },
  bsc: {
    chainId: 56,
    serverUrl: 'https://bsc-clarity.a.exodus.io/',
    confirmationsNumber: 15,
    monitorType: 'clarity',
    tokenType: 'BSC_BEP20',
  },
  matic: {
    chainId: 137,
    serverUrl: 'https://polygon-clarity.a.exodus.io/',
    monitorType: 'clarity',
    confirmationsNumber: 50,
  },
  avalanchec: {
    chainId: 43_114,
    serverUrl: 'https://avax-c.a.exodus.io/wallet/v1/',
    confirmationsNumber: 30,
    tokenType: 'AVAX_ERC20',
  },
  fantommainnet: {
    chainId: 250,
    serverUrl: 'https://fantom.a.exodus.io/wallet/v1/',
    confirmationsNumber: 3,
  },
  harmonymainnet: {
    chainId: 1_666_600_000,
    serverUrl: 'https://harmony.a.exodus.io/wallet/v1/',
    confirmationsNumber: 6,
  },
  ethereumarbnova: {
    chainId: 42_170,
    serverUrl: 'https://nova.arbitrum.io/rpc',
    confirmationsNumber: 3,
    monitorType: 'no-history',
  },
  ethereumarbone: {
    chainId: 42_161,
    serverUrl: 'https://arbitrum-one-clarity.a.exodus.io',
    confirmationsNumber: 3,
    monitorType: 'clarity',
  },
  optimism: {
    chainId: 10,
    serverUrl: 'https://optimism-clarity.a.exodus.io',
    confirmationsNumber: 3,
    monitorType: 'clarity',
    tokenType: 'OPT_ERC20',
  },
  rootstock: {
    chainId: 30,
    serverUrl: 'https://rsk.a.exodus.io',
    confirmationsNumber: 3,
    monitorType: 'no-history',
  },
  flare: {
    chainId: 14,
    serverUrl: 'https://flare-nn.a.exodus.io/ext/C/rpc',
    confirmationsNumber: 30,
    monitorType: 'no-history',
  },
  aurora: {
    chainId: 1_313_161_554,
    serverUrl: 'https://aurora.a.exodus.io',
    confirmationsNumber: 3,
    monitorType: 'no-history',
  },
  basemainnet: {
    chainId: 8453,
    serverUrl: 'https://base-qn.a.exodus.io',
    confirmationsNumber: 30,
    monitorType: 'no-history',
  },
  cronos: {
    chainId: 25,
    serverUrl: 'https://cronos.a.exodus.io',
    confirmationsNumber: 6,
    monitorType: 'no-history',
  },
  mantle: {
    chainId: 5000,
    serverUrl: 'https://mantle-qn.a.exodus.io',
    confirmationsNumber: 30,
    monitorType: 'no-history',
  },
  mantlesepolia: {
    chainId: 5003,
    serverUrl: 'https://mantle-sepolia-qn.a.exodus.io',
    confirmationsNumber: 30,
    monitorType: 'no-history',
  },
  ethereumarbonesepolia: {
    chainId: 421_614,
    serverUrl: 'https://arbitrum-sepolia-qn.a.exodus.io',
    confirmationsNumber: 3,
    monitorType: 'no-history',
  },
}

/* @deprecated */
export const DEFAULT_SERVER_URLS = mapValues(CHAIN_DATA, ({ serverUrl }) => serverUrl)
/* @deprecated */
export const ETHEREUM_LIKE_MONITOR_TYPES = mapValues(
  CHAIN_DATA,
  ({ monitorType }) => monitorType || 'magnifier'
)
/* @deprecated */
export const CHAIN_IDS = mapValues(CHAIN_DATA, ({ chainId }) => chainId)

export const MIN_GASPRICE = 1e9 // 1 gwei
export const DEFAULT_FEE_MONITOR_INTERVAL = '1m'
/* @deprecated */
export const CONFIRMATIONS_NUMBER = mapValues(
  CHAIN_DATA,
  ({ confirmationsNumber }) => confirmationsNumber
)
/* @deprecated */
export const ETHEREUM_LIKE_ASSETS = Object.keys(CHAIN_DATA)

export const BUMP_RATE = 1.2
/* @deprecated */
export const ETHEREUM_LIKE_NO_HISTORY_ASSET_NAMES = Object.keys(CHAIN_DATA).filter(
  (key) => CHAIN_DATA[key].monitorType === 'no-history'
)
